define("calendar/utils/markupBuilders", ["exports", "shared/utils/escape-html"], function (_exports, _escapeHtml) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  0; //eaimeta@70e063a35619d71f0,"shared/utils/escape-html"eaimeta@70e063a35619d71f
  const getPostStatusAndMethodMarkup = _ref => {
    let {
      className = '',
      icon = '',
      text = '',
      overlay = ''
    } = _ref;
    return `<span class='${className}'><span class='${icon}'></span> ${text}</span>${overlay}`;
  };
  const getUniversalPostMarkup = (eventId, profileColorClass, imageOrTextMarkup) => {
    return `
  <div class='fc-content fc-event-${eventId} ${profileColorClass}'>
    ${imageOrTextMarkup}
  </div>`;
  };
  const getEventTimeMarkup = formattedEventTime => {
    return `<div class='fc-event-time'>${formattedEventTime}</div>`;
  };
  const getTextPostMarkup = caption => {
    return `<p class="fc-event-text">${caption}</p>`;
  };
  const getImagePostMarkup = calendarOrProcessingUrl => {
    return `
    <div class='fc-event-img'>
      <img src='${calendarOrProcessingUrl}'>
    </div>`;
  };
  const getBttpSvgMarkup = () => {
    return `
    <svg class='fc-bttp-icon' width='100%' height='100%' viewBox='0 0 28 28' version='1.1' xmlns='http://www.w3.org/2000/svg' style='fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2;'>
      <path d='m19.25 4.667-1.762 4.025-3.558-6.277-3.547 6.452-1.633-4.2s-4.258 7.91-4.258 11.526c0 5.25 4.258 9.509 9.508 9.509 5.25 0 9.508-4.259 9.508-9.509 0-3.78-4.258-11.526-4.258-11.538v.012ZM14 22.132c-3.115 0-5.833-2.695-5.833-5.799 0-1.166.536-2.391 1.225-3.5l2.275 3.5L14 10.5l2.333 5.833 2.275-3.5c.677 1.109 1.225 2.334 1.225 3.5 0 3.104-2.718 5.799-5.833 5.799Z'/>
    </svg>
    `;
  };
  const getNoteHintMarkup = (formattedDate, notesLength) => {
    return `
  <span class='fc-note-${formattedDate}'>
    <span class='u--text--hl'>(${notesLength})</span>
    <span class='fc-icon-note'></span>
  </span>`;
  };
  const getNoteMarkup = (intlService, noteSummary) => {
    return `
  <span class='fc-action'>
    <span class='fc-icon-move'></span>
  </span>
  <span class='fc-note_icon'>
    <span class='fc-icon-note'></span>
  </span>
  <div class='fc-note_text'>
     ${noteSummary}
   </div>
   <span class='fc-note_hint'>
     ${intlService.t('calendar_notes.view_note')}
   </span>`;
  };
  const getBttpPromoMarkup = intlService => {
    return `
    <button class='o--btn--a11y u--p__r__sm'>${intlService.t('bttp.discoverability.enable_your_bttp')}</button>
    <svg width='28' height='28' viewBox='0 0 28 28' xmlns='http://www.w3.org/2000/svg'><path fill-rule='evenodd' clip-rule='evenodd' d='m19.25 4.667-1.762 4.025-3.558-6.277-3.547 6.452-1.633-4.2s-4.258 7.91-4.258 11.526c0 5.25 4.258 9.509 9.508 9.509 5.25 0 9.508-4.259 9.508-9.509 0-3.78-4.258-11.526-4.258-11.538v.012ZM14 22.132c-3.115 0-5.833-2.695-5.833-5.799 0-1.166.536-2.391 1.225-3.5l2.275 3.5L14 10.5l2.333 5.833 2.275-3.5c.677 1.109 1.225 2.334 1.225 3.5 0 3.104-2.718 5.799-5.833 5.799Z' fill='currentColor'/></svg>
  `;
  };
  const getNotesPromoMarkup = intlService => {
    return `
    <button class='o--btn--a11y u--p__r__sm'>${intlService.t('calendar_notes.add_note')}</button>
    <svg width="100%" height="100%" viewBox="0 0 28 28" xmlns="http://www.w3.org/2000/svg">
      <path fill-rule="evenodd" fill="currentColor" d="M13.845 5.384a.985.985 0 00.012.013l.586.585L11.825 8.6H8.152a.967.967 0 00-.685.29L4.89 11.469a.952.952 0 000 1.37l4.434 4.434-8.283 8.317a.952.952 0 000 1.37.967.967 0 00.685.291.967.967 0 00.685-.29l8.283-8.282 4.434 4.433a.967.967 0 00.685.291.967.967 0 00.685-.29l2.578-2.578a.967.967 0 00.29-.685v-3.672l2.62-2.617.585.585a.967.967 0 00.685.291.967.967 0 00.685-.291l2.578-2.577c.962-.923.975-2.46.036-3.44l-6.68-6.679c-.933-.932-2.468-.932-3.436-.003l-2.582 2.58a.967.967 0 00-.29.686c0 .247.097.485.278.672zm3.987-2.503c.21-.191.494-.152.628-.017l6.66 6.659c.194.211.147.474.015.6l-.015.015-1.51 1.51a.5.5 0 01-.708 0l-.563-.563a.5.5 0 00-.707 0l-4.119 4.117a.5.5 0 00-.146.354v3.651a.5.5 0 01-.147.354l-1.053 1.053a.5.5 0 01-.708 0l-3.327-3.327.018-.018-4.763-4.762a.5.5 0 010-.707l1.053-1.054a.5.5 0 01.354-.146h3.652a.5.5 0 00.354-.146l4.118-4.118a.5.5 0 000-.707l-.563-.564a.5.5 0 010-.707l1.477-1.477z" clip-rule="evenodd"></path>
    </svg>`;
  };
  const getTimeSlotMarkup = () => {
    return `
  <div class='fc-destroy'>
    <span class='fc-icon-close e--fc-slot-destroy'></span>
  </div>
  <span class='fc-action'>
    <span class='fc-icon-move'></span>
  </span>`;
  };
  const getBttpTooltipMarkup = (intlService, bttpProps) => {
    return `
    <p class="fc-bttp-tooltip__text u--text--xs">${intlService.t('calendar.bttp.tooltip')}</p>
    <div class="fc-bttp-tooltip__profile ${(0, _escapeHtml.default)(bttpProps.profileColorClass)}">
      <span class="${(0, _escapeHtml.default)(bttpProps.avatarChildClass ?? '')} fc-bttp-tooltip__profile-icon">
        <i class="${(0, _escapeHtml.default)(bttpProps.profileIconClass ?? '')}"></i>
      </span>
      <p class="u--ellipsis u--m__0">${(0, _escapeHtml.default)(bttpProps.profileName ?? '')}</p>
    </div>`;
  };
  const getBttpOverflowIndicatorMarkup = () => {
    return `
    <svg class="o--icon--sm" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 28 28" fill="currentColor">
        <circle cx="6" cy="14" r="2.5"/>
        <circle cx="14" cy="14" r="2.5"/>
        <circle cx="22" cy="14" r="2.5"/>
    </svg>
  `;
  };
  var _default = _exports.default = {
    bttpSvg: getBttpSvgMarkup,
    noteHint: getNoteHintMarkup,
    note: getNoteMarkup,
    notesPromo: getNotesPromoMarkup,
    timeSlot: getTimeSlotMarkup,
    bttpPromo: getBttpPromoMarkup,
    universalPostContent: getUniversalPostMarkup,
    postStatusAndMethodContent: getPostStatusAndMethodMarkup,
    eventTime: getEventTimeMarkup,
    imagePost: getImagePostMarkup,
    textPost: getTextPostMarkup,
    bttpTooltip: getBttpTooltipMarkup,
    bttpOverflowIndicator: getBttpOverflowIndicatorMarkup
  };
});